<template>
  <div class="border-right text-light shadow-lg" id="sidebar-wrapper">
    <div class="sidebar-heading text-start">فروشگاه ستاوین</div>
    <ul class="list-group list-group-flush text-start">
      <li><hr class="dropdown-divider" /></li>

      <li
        class="bg-dark-theme list-group-item list-group-item-action text-light fs-6 border-0"
      >
        <router-link
          class="text-decoration-none text-light"
          :to="{ name: 'Profile' }"
        >
          <i class="fas fa-user"></i>
          {{ this.$store.state.fullName }}
        </router-link>
      </li>

      <li><hr class="dropdown-divider" /></li>

      <li
        v-for="item in menus"
        :key="item.id"
        :class="menuActiveId == Number(item.id) ? 'active' : 'bg-dark-theme'"
        class="list-group-item list-group-item-action text-light fs-6"
      >
        <router-link
          :to="item.href"
          v-if="item.slug === `link`"
          class="text-decoration-none text-light"
          @click="changeActiveId(item.id)"
        >
          <i :class="item.icon"></i>
          {{ item.name }}
        </router-link>

        <a
          href="#"
          v-else-if="item.slug === `dropdown`"
          class="collapsed d-flex justify-content-between text-decoration-none text-light w-100"
          :data-bs-target="`#dashboard-collapse-` + item.id"
          data-bs-toggle="collapse"
        >
          <span>
            <i :class="item.icon"></i>
            {{ item.name }}
          </span>
          <span class="fas fa-angle-down"></span>
        </a>
        <div
          :class="getDropDownClass(item.elements)"
          :id="`dashboard-collapse-` + item.id"
        >
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small pe-2">
            <li
              v-for="subItem in item.elements"
              :key="subItem.id"
              :class="getSubMenuClass(subItem.id, item.id)"
              class="list-group-item text-light m-3 w-100"
            >
              <router-link
                :to="subItem.href"
                class="text-decoration-none text-white"
                @click="changeActiveId(subItem.id)"
              >
                <i :class="subItem.icon"></i>
                {{ subItem.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
  name: "TheSidemenu",
  data() {
    return {
      name: process.env.VUE_APP_TITLE,
      menus: this.$store.state.menus,
      menuActiveId: this.$store.state.menuActiveId,
      openDropDownItem: -1,
      diaplay_parent: "collapse",
      menuToggle: this.$store.state.menuToggle,
    };
  },
  methods: {
    changeActiveId: function (menuId) {
      this.menuActiveId = menuId;
      this.$store.commit("set", ["menuActiveId", this.menuActiveId]);
      if(isMobile){
        this.$store.commit("set", ["menuToggle", "toggled"]);
      }
    },
    getSubMenuClass: function (subItemId, itemId) {
      this.openDropDownItem =
        this.menuActiveId == Number(subItemId) ? itemId : -1;
      return this.menuActiveId == Number(subItemId)
        ? "active"
        : "bg-dark-theme";
    },
    getDropDownClass: function (elements) {
      for (let i in elements) {
        if (elements[i].id === this.menuActiveId) {
          return "";
        }
      }
      return "collapse";
    }
  },
};
</script>
